import {
  CssBaseline,
  createTheme,
  type ThemeOptions,
  ThemeProvider,
} from '@mui/material';
import { type PropsWithChildren, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { setStyle } from '../map/map.slice';
import TenantId from '../tenant';
import { getFromTheme, setTheme, type Tenant } from '../theme';
import ThemeConfig from './theme-config';

type AppThemeProviderProps = PropsWithChildren;

const tenantForDomain = (): Tenant => TenantId.GEOLLECT;

function AppThemeProvider({ children }: AppThemeProviderProps) {
  const { idToken } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const [tenant, setTenant] = useState<Tenant>(tenantForDomain);

  useEffect(() => {
    if (idToken?.tenantId && idToken.tenantId in TenantId) {
      setTenant(idToken.tenantId);
    } else {
      setTenant(tenantForDomain);
    }
  }, [idToken?.tenantId]);

  useEffect(() => {
    if (tenant) {
      setTheme(tenant);
      dispatch(setStyle(getFromTheme('mapboxStyle')));
    }
  }, [tenant]);

  return (
    <ThemeProvider
      theme={createTheme(
        (ThemeConfig[tenant] as ThemeOptions) || ThemeConfig[TenantId.GEOLLECT]
      )}
    >
      <CssBaseline>{children}</CssBaseline>
    </ThemeProvider>
  );
}

export default AppThemeProvider;
